import { render, staticRenderFns } from "./ShuttleRegister.vue?vue&type=template&id=ee6ed7a2"
import script from "./ShuttleRegister.vue?vue&type=script&lang=js"
export * from "./ShuttleRegister.vue?vue&type=script&lang=js"
import style0 from "./ShuttleRegister.vue?vue&type=style&index=0&id=ee6ed7a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports